const states = {
  query_details: {
    available_dates: [],
    cluster_data: {},
    word_cloud: [],
    table_data: [],
    utterance_data: [],
    clusters_table_filters: {
      limit: 10,
      skip: 0,
    },
    table_pagination: {
      more_pages: true,
      current: 1,
    },
    loaders: {
      cluster_data_loading: false,
      cluster_data_load_error: false,
      table_data_loading: false,
      table_data_load_error: false,
      utterance_data_loading: false,
      utterance_data_load_error: false,
    },
    word_cloud_data_loading: false,
    word_cloud_data_load_error: false
  },
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/query_details/states.js